import { useCookies } from 'vue3-cookies';
const { cookies } = useCookies();
export default {
  getAdminNoticeList(state) {
    return state.adminNotice.list;
  },

  getNoticeList(state) {
    return state.notice.list;
  },

  getPageInfo(state) {
    return state.pageInfo;
  },

  getNotice(state) {
    return state.notice.content;
  },

  getEventList(state) {
    return state.event.list;
  },

  getEvent(state) {
    return state.event.content;
  },

  getList(state) {
    return state.list;
  },

  getDetail(state) {
    return state.detail;
  }
};
